import './App.css';
import Router from './router/router';
import { LoadingProvider } from './context/LoadingContext';

function App() {

  return(
    <LoadingProvider>
      <Router />
    </LoadingProvider>
    
  )
}

export default App;
